import {ChangeDetectorRef} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {
  CartItem,
  ServiceOffer,
  serviceOfferComponentKey,
} from '../../../data/model';

abstract class ServiceOfferFormComponent {
  abstract serviceOffer: ServiceOffer | undefined;
  abstract offerForm: FormGroup;

  constructor(protected ref: ChangeDetectorRef) {}

  markAllAsTouched(): void {
    this.offerForm.markAllAsTouched();
    this.ref.markForCheck();
    this.ref.detectChanges();
  }

  value(): CartItem {
    let cartItemId: string | undefined = undefined;
    if (this.serviceOffer?.references?.registration?.id) {
      cartItemId = `${this.serviceOffer.id}-${this.serviceOffer.references.registration.id}`;
    }
    const unitPrice = this.serviceOffer?.quote
      ? this.serviceOffer.quote.cost
      : this.serviceOffer?.price;
    return new CartItem({
      id: cartItemId,
      name: this.serviceOffer?.name,
      productId: this.serviceOffer?.id || '',
      unitPrice: unitPrice || 0,
      quantity: 1,
      quote: this.serviceOffer?.quote,
      references: this.serviceOffer?.references,
      taxCode: this.serviceOffer?.taxCode,
      templateKey: this.serviceOffer?.templateKey || serviceOfferComponentKey,
      itemVariationId: this.serviceOffer?.itemVariationId,
      fulfilledBy: this.serviceOffer?.fulfillment ?? undefined,
    });
  }

  valid(): boolean {
    return this.offerForm && this.offerForm.valid;
  }

  abstract bindFormValue(value: boolean, item?: CartItem): void;
  abstract addonSelected(): boolean;
}

export {ServiceOfferFormComponent};
